'use strict'

Object.defineProperty(exports, '__esModule', {
  value: true
})

var _templateObject = _taggedTemplateLiteral(
  [
    '\n  box-shadow: none !important;\n  background-color: transparent !important;\n  color: ',
    ';\n  border-width: 2px;\n  border-style: solid;\n  border-color: currentColor;\n'
  ],
  [
    '\n  box-shadow: none !important;\n  background-color: transparent !important;\n  color: ',
    ';\n  border-width: 2px;\n  border-style: solid;\n  border-color: currentColor;\n'
  ]
)

var _Button = require('./Button')

var _Button2 = _interopRequireDefault(_Button)

var _theme = require('./theme')

var _theme2 = _interopRequireDefault(_theme)

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj }
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(
    Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })
  )
}

var OutlineButton = _Button2.default.extend(_templateObject, function(props) {
  return (0, _theme.cx)(props.color)
})

OutlineButton.displayName = 'OutlineButton'

OutlineButton.defaultProps = {
  theme: _theme2.default,
  color: 'primary',
  f: 3,
  m: 0,
  px: 3,
  py: 2
}

exports.default = OutlineButton



//////////////////
// WEBPACK FOOTER
// ./~/@hackclub/design-system/dist/OutlineButton.js
// module id = 180
// module chunks = 168707334958949